module.exports = __webpack_public_path__ + "static/icons-24-e82bbcdc50d17f9687f9374c3134ad1d.svg";